import React, { useEffect, useState, useRef, useContext } from 'react';
import Controls_Map_Floors from '../InteractiveMap/Controls_Map_Floors';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import Render_MapEditor from './Render_MapEditor';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Card from '../ERUMAUI/UI_Card';
import Icon_View from '../../Assets/Icons/Icon_View.png';
import Icon_Edit from '../../Assets/Icons/Icon_Edit.png';
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png';
import Icon_Target from '../../Assets/Icons/Icon_Target.png';
import Icon_Expand from '../../Assets/Icons/Icon_Expand.png';
import Icon_Collapse from '../../Assets/Icons/Icon_Collapse.png';
import Icon_Link from '../../Assets/Icons/Icon_Link.png';

export default function Panel_MapEditor_Center() {
    // const { Account, Loading } = useAuth();


    const { Map_Composition, Information_Display, Building_Switch, Floor_Switch, Room_Highlight, Map_Information } = useMapRenderer();
    const { Map_Editing_Set, Map_Editing_Mode_Set, Item_Delete_Confirm } = useMapEditor();
    const UI = useContext(Context_UI);
    const [Buildings_Expanded, Buildings_Expanded_Set] = useState({});
    const [Floors_Expanded, Floors_Expanded_Set] = useState({});
    const { Slide_Switch } = useStatus();
    const [Buildings_Count, Buildings_Count_Set] = useState(0);
    const [Floors_Count, Floors_Count_Set] = useState(0);
    const [Rooms_Count, Rooms_Count_Set] = useState(0);
    useEffect(() => {
        Counts_Get();
    }, []);

    const Building_Toggle = (Index) => {
        Buildings_Expanded_Set((Prev) => ({
            ...Prev,
            [Index]: !Prev[Index]
        }));
    }

    const Floor_Toggle = (Index_Building, Index_Floor) => {
        const Key = `${Index_Building}_${Index_Floor}`;
        Floors_Expanded_Set((Prev) => ({
            ...Prev,
            [Key]: !Prev[Key]
        }));
    }

    const Collapse_All = () => {
        Buildings_Expanded_Set([]);
        Floors_Expanded_Set([]);
    }

    const Expand_All = () => {
        const Buildings_All = {};
        Map_Composition.forEach((Item, Index) => { Buildings_All[Index] = true; });
        Buildings_Expanded_Set(Buildings_All);

        const Floors_All = {};
        Map_Composition.forEach((Building, Index_Building) => {
            Floors_All[Index_Building] = Building.Floors.map((Item, Index_Floor) => { Floors_All[`${Index_Building}_${Index_Floor}`] = true; });
        });
        Floors_Expanded_Set(Floors_All);
    }

    const Preview_Building = (Building) => {
        Slide_Switch("/map_editor");
        setTimeout(function () {
            Building_Switch(Building);
        }, 250);
    }

    const Preview_Floor = (Building, Floor) => {
        Slide_Switch("/map_editor");
        setTimeout(function () {
            Floor_Switch(Building, Floor);
        }, 250);
    }

    const Preview_Room = (Room_ID) => {
        Slide_Switch("/map_editor");
        setTimeout(function () {
            Room_Highlight(Room_ID, 4, 400, "Directory");
        }, 400);
    }

    const Counts_Get = () => {
        let Buildings_Count = Map_Composition.length;
        let Floors_Count = 0;
        let Rooms_Count = 0;

        Map_Composition.forEach(Building => {
            Floors_Count += Building.Floors.length;
            Building.Floors.forEach(Floor => {
                Rooms_Count += Floor.Rooms.length;
            });
        });
        Buildings_Count_Set(Buildings_Count);
        Floors_Count_Set(Floors_Count);
        Rooms_Count_Set(Rooms_Count);
    }

    const Handle_Delete = (Type, ID) => {
        Information_Display(Type, ID);
        setTimeout(function () {
            Item_Delete_Confirm(Type)
        }, 500);
    }

    const Generate_Table_Floors = (Building) => {
        return (
            <>
                {Map_Composition[Building].Floors.length > 0 ?
                    <div className='ME_Table' Level="Floors">
                        <div className='ME_Table_Header'>
                            <div className='ME_Table_Row'>
                                <p className='ME_Table_Cell'>
                                    Floor level
                                </p>
                                <p className='ME_Table_Cell'>
                                    Floor name
                                </p>
                                <p className='ME_Table_Cell'>
                                    Rooms
                                </p>
                                <p className='ME_Table_Cell'>
                                    Controls
                                </p>
                            </div>
                        </div>

                        {Map_Composition[Building].Floors.map((Floor, Floor_Index) => (
                            <>
                                <div className='ME_Table_Content'>
                                    <div className='ME_Table_Row' State={Map_Information?._id == Floor._id ? "Active" : "Inactive"}>
                                        <p className='ME_Table_Cell'>
                                            {Floor.Number}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Floor.Name}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Floor.Rooms.length}
                                        </p>
                                        <div className='ME_Table_Cell'>
                                            <div className='ME_Table_Controls'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => {
                                                        Information_Display("Floor", Floor._id);
                                                        Map_Editing_Set(false);
                                                        Map_Editing_Mode_Set("");
                                                    }} />
                                                    <UI_Button Icon={Icon_Edit} Type="Icon" Icon_Position="Center"
                                                        // OnClick={() => {
                                                        // Information_Display("Floor", Floor._id);
                                                        // Map_Editing_Set(true);
                                                        // Map_Editing_Mode_Set("Regular");
                                                        // }}
                                                        OnClick={async () => {

                                                            Map_Editing_Set(false);
                                                            Map_Editing_Mode_Set("");


                                                            await Information_Display("Floor", Floor._id);


                                                            // setTimeout(() => {
                                                                Map_Editing_Set(true);
                                                                Map_Editing_Mode_Set("Regular");
                                                            // }, 1000);
                                                        }}
                                                    />
                                                    {/* <UI_Button Icon={Icon_Target} Type="Icon" Icon_Position="Center" OnClick={() => Preview_Floor(Building, Floor_Index)} /> */}
                                                    <UI_Button Icon={Icon_Delete} Type="Icon" Icon_Position="Center"
                                                        OnClick={() => {
                                                            Information_Display("Floor", Floor._id);
                                                            Item_Delete_Confirm("Floor");
                                                        }} />
                                                </UI_LinearGroup>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Floors_Expanded[`${Building}_${Floor_Index}`] ? Icon_Collapse : Icon_Expand} Type="Icon" Icon_Position="Center" OnClick={() => Floor_Toggle(Building, Floor_Index)} />
                                                </UI_LinearGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {Floors_Expanded[`${Building}_${Floor_Index}`] && Generate_Table_Rooms(Building, Floor_Index)}
                                </div>
                                {Map_Composition[Building].Floors.length - 1 !== Floor_Index && Floors_Expanded[`${Building}_${Floor_Index}`] ?
                                    <div className='ME_Table_Header'>
                                        <div className='ME_Table_Row'>
                                            <p className='ME_Table_Cell'>
                                                Floor level
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Floor name
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Rooms
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Controls
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    ""
                                }
                            </>

                        ))}
                    </div>
                    :
                    <div className='ME_Table' Level="Floor">
                        <div className='ME_Table_Header'>
                            <p className='ME_Table_Cell'>
                                The building is empty.
                            </p>
                        </div>
                    </div>
                }

            </>
        );
    }

    const Generate_Table_Rooms = (Building, Floor) => {
        return (
            <>
                {Map_Composition[Building].Floors[Floor].Rooms.length > 0 ?
                    <div className='ME_Table' Level="Room">
                        <div className='ME_Table_Header'>
                            <div className='ME_Table_Row'>
                                <p className='ME_Table_Cell'>
                                    Room code
                                </p>
                                <p className='ME_Table_Cell'>
                                    Room name
                                </p>
                                <p className='ME_Table_Cell'>
                                    Type
                                </p>
                                {/* <p className='ME_Table_Cell'>
                                    Capacity
                                </p> */}
                                <p className='ME_Table_Cell'>
                                    Controls
                                </p>
                            </div>
                        </div>
                        <div className='ME_Table_Content'>
                            {Map_Composition[Building].Floors[Floor].Rooms.map((Room, Room_Index) => (
                                <>
                                    <div className='ME_Table_Row' State={Map_Information?._id == Room._id ? "Active" : "Inactive"}>
                                        <p className='ME_Table_Cell'>
                                            {Room.Location.Code}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Room.Name}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Room.Type}
                                        </p>
                                        {/* <p className='ME_Table_Cell'>
                                            {Room.Capacity}
                                        </p> */}
                                        <div className='ME_Table_Cell'>
                                            <div className='ME_Table_Controls'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => {
                                                        Information_Display("Room", Room._id);
                                                        Map_Editing_Set(false);
                                                        Map_Editing_Mode_Set("");
                                                    }} />
                                                    <UI_Button Icon={Icon_Edit} Type="Icon" Icon_Position="Center"
                                                        OnClick={async () => {

                                                            Map_Editing_Set(false);
                                                            Map_Editing_Mode_Set("");


                                                            await Information_Display("Room", Room._id);


                                                            // setTimeout(() => {
                                                                Map_Editing_Set(true);
                                                                Map_Editing_Mode_Set("Regular");
                                                            // }, 1000);
                                                        }}
                                                    />
                                                    {/* <UI_Button Icon={Icon_Target} Type="Icon" Icon_Position="Center" OnClick={() =>
                                                        Preview_Room(Room._id)
                                                    } /> */}
                                                    <UI_Button Icon={Icon_Delete} Type="Icon" Icon_Position="Center" OnClick={() => {
                                                        Information_Display("Room", Room._id);
                                                        Item_Delete_Confirm("Room");
                                                    }} />
                                                </UI_LinearGroup>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    {/* <UI_Button Icon={Icon_Link} Type="Icon" Icon_Position="Center" /> */}
                                                </UI_LinearGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {/* {Generate_Table_Floors(Building_Index)} */}
                                </>

                            ))}
                        </div>
                    </div>
                    :
                    <div className='ME_Table' Level="Room">
                        <div className='ME_Table_Header'>
                            <p className='ME_Table_Cell'>
                                The floor is empty.
                            </p>
                        </div>
                    </div>
                }

            </>
        );
    }



    return (
        <>
            <div style={{ display: "flex", gap: "10px", padding: "10px", paddingBottom: "5px" }}>
                <UI_Card Shape="Rectangle" Text="Total buildings" Figure={Buildings_Count} />
                <UI_Card Shape="Rectangle" Text="Total floors" Figure={Floors_Count} />
                <UI_Card Shape="Rectangle" Text="Total rooms" Figure={Rooms_Count} />
            </div>
            <div style={{ maxWidth: "300px", padding: "10px", paddingTop: "5px" }}>
                <UI_LinearGroup Direction="Row" Gap="Gap" Fill>
                    <UI_Button Icon={Icon_Expand} Type="Icon" Icon_Position="Left" Text="Expand all" OnClick={() => Expand_All()} />
                    <UI_Button Icon={Icon_Collapse} Type="Icon" Icon_Position="Left" Text="Collapse all" OnClick={() => Collapse_All()} />
                </UI_LinearGroup>
            </div>

            {Map_Composition.length > 0 ?
                <>
                    <div className='ME_Table' Level="Buildings">
                        <div className='ME_Table_Header'>
                            <div className='ME_Table_Row'>
                                <p className='ME_Table_Cell'>
                                    Building name
                                </p>
                                <p className='ME_Table_Cell'>
                                    Address
                                </p>
                                <p className='ME_Table_Cell'>
                                    Floors
                                </p>
                                <p className='ME_Table_Cell'>
                                    Controls
                                </p>
                            </div>
                        </div>

                        {Map_Composition.map((Building, Building_Index) => (
                            <>
                                <div className='ME_Table_Content'>
                                    <div className='ME_Table_Row' key={Building_Index} State={Map_Information?._id == Building._id ? "Active" : "Inactive"}>
                                        <p className='ME_Table_Cell'>
                                            {Building.Name}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Building.Address}
                                        </p>
                                        <p className='ME_Table_Cell'>
                                            {Building.Floors.length}
                                        </p>
                                        <div className='ME_Table_Cell'>
                                            <div className='ME_Table_Controls'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => {
                                                        Information_Display("Building", Building._id);
                                                        Map_Editing_Set(false);
                                                        Map_Editing_Mode_Set("");
                                                    }} />
                                                    <UI_Button Icon={Icon_Edit} Type="Icon" Icon_Position="Center"
                                                        //     OnClick={() => {
                                                        //     Information_Display("Building", Building._id);
                                                        //     Map_Editing_Set(true);
                                                        //     Map_Editing_Mode_Set("Regular");
                                                        // }}
                                                        OnClick={async () => {

                                                            Map_Editing_Set(false);
                                                            Map_Editing_Mode_Set("");


                                                            await Information_Display("Building", Building._id);



                                                            Map_Editing_Set(true);
                                                            Map_Editing_Mode_Set("Regular");

                                                        }}
                                                    />
                                                    {/* <UI_Button Icon={Icon_Target} Type="Icon" Icon_Position="Center" OnClick={() => Preview_Building(Building_Index)} /> */}
                                                    <UI_Button Icon={Icon_Delete} Type="Icon" Icon_Position="Center" OnClick={() => {
                                                        Handle_Delete("Building", Building._id)
                                                    }} />
                                                </UI_LinearGroup>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Buildings_Expanded[Building_Index] ? Icon_Collapse : Icon_Expand} Type="Icon" Icon_Position="Center" OnClick={() => Building_Toggle(Building_Index)} />
                                                </UI_LinearGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {Buildings_Expanded[Building_Index] && Generate_Table_Floors(Building_Index)}
                                </div>
                                {Map_Composition.length - 1 !== Building_Index && Buildings_Expanded[Building_Index] ?
                                    <div className='ME_Table_Header'>
                                        <div className='ME_Table_Row'>
                                            <p className='ME_Table_Cell'>
                                                Building name
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Address
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Floors
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                Controls
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    ""
                                }


                            </>


                        ))}

                    </div>
                </>

                :
                ""
            }
        </>
    );

}


